import styled, { keyframes } from 'styled-components'
import { StyledTransLink } from 'layouts/Default/header'
import { color, grey } from 'const/colors'
import media from 'styles/media'
import Button from 'components/Button'
import HeaderSection from 'components/Section/headerSection'

export const PageContainer = styled.div`
  & * {
    box-sizing: border-box;
  }
`

export const LoadMore = styled(StyledTransLink)`
  font-weight: 400;
  font-size: 1.5em;
`

export const BlogArticlesWrapper = styled.div`
  background-color: ${grey};
  margin-top: 150px;
`

export const BlogArticles = styled.div`
  position: relative;
  top: -160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 2560px;
  margin-left: auto;
  margin-right: auto;
`

export const BlogArticlesGrid = styled.div`
  width: 100%;
  padding: 70px 248px 140px;
  display: grid;
  row-gap: 1em;
  column-gap: 1em;
  grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));

  ${media.desktop`
    padding: 54px 136px;
  `}

  ${media.tablet`
    padding: 54px 24px;
  `}
`

export const CardMedia = styled.div`
  background-size: cover;
  background-position: 50% 50%;
  min-height: 50%;
`

export const CardContent = styled.div`
  padding: 0;
  overflow: hidden;
  margin: 10px 25px;
  color: ${color.black.o100};
`

const CardHover = keyframes`
  0% {
    transform: translateY(0px) scale(1);
  }
  
  50% {
    transform: translateY(-3px) scale(1.0059);
    box-shadow: 0 2px 6px -1px rgba(0,0,0,0.75);
  }
  
  100% {
    transform: translateY(-2px) scale(1.005);
    box-shadow: 0 2px 5px -1px rgba(0,0,0,0.75);
  }
`

export const StyledCardContainer = styled.div`
  box-sizing: border-box;
  background-color: white;
  position: relative;
  flex-basis: calc(33.33% - 10px);
  transition: box-shadow 0.2s ease, transform 0.2s ease;

  &::before {
    content: '';
    display: block;
    padding-top: 130%;
  }
  @media (hover: hover) and (pointer: fine) {
    &::after {
      content: '';
      background-color: ${color.primary.o100};
      height: 5px;
      bottom: 0;
      display: block;
      position: absolute;
      width: 0;
      transition: width 0.2s ease;
    }

    &:hover {
      box-shadow: 0 2px 5px -1px rgba(0, 0, 0, 0.75);
      transform: scale(1.005) translateY(-2px);
      animation: ${CardHover} 0.2s ease;

      &::after {
        width: 100%;
      }
    }
  }
`

export const InnerCard = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const CategoryTile = styled.div`
  background-color: ${color.primary.o100};
  color: ${color.white.o100};
  display: flex;
  align-items: center;
  padding: 5px;
  width: fit-content;

  & svg {
    margin: 0 5px;
  }
`

export const Category = styled(CategoryTile)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  margin-left: 25px;
`

export const Categories = styled.div`
  display: flex;
  flex: 0 1 auto;
  margin-right: 248px;
  ${media.desktop`
    margin: 0 136px 25px;
  `}

  ${media.tablet`
    margin: 0 24px;
    flex-wrap: wrap;
    flex: 0;
  `}
`

export const CategoryFilter = styled(Button)`
  background-color: ${({ selected }) =>
    selected ? color.primary.o100 : color.transparent};
  color: ${({ selected }) =>
    selected ? color.white.o100 : color.primary.o100};
  margin: 5px;
  padding: 10px;
  ${media.phone`
    // overrides the default 50px margin on media.phone
    margin-bottom: 5px;
  `}
`

export const BlogHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  ${media.tablet`
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  `}

  max-width: 2560px;
  margin-left: auto;
  margin-right: auto;
`

export const Title = styled.h1`
  font-size: 20px;
`

export const DateTime = styled.p`
  font-size: 14px;
`

export const Paragraph = styled.div`
  font-size: 14px;
`

export const StyledHeaderSection = styled(HeaderSection)`
  flex: 0;
`
